"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertTime = exports.scaleNumber = void 0;
var scaleNumber = function (value, minVal, midVal, maxVal) {
    if (minVal === void 0) { minVal = 10; }
    if (midVal === void 0) { midVal = 28; }
    if (maxVal === void 0) { maxVal = 120; }
    if (value < 0 || value > 1) {
        throw new Error("Input value must be between 0 and 1");
    }
    var midPoint = 0.5;
    if (value < midPoint) {
        // Scale between minVal and midVal
        return minVal + (midVal - minVal) * (value / midPoint);
    }
    else {
        // Scale between midVal and maxVal
        return midVal + (maxVal - midVal) * ((value - midPoint) / (1 - midPoint));
    }
};
exports.scaleNumber = scaleNumber;
// Function to convert time to a string
// Potentially deprecated after the refactor
var convertTime = function (time) {
    var hours = Math.floor(time / 60);
    var minutes = time % 60;
    var period = hours >= 12 ? "PM" : "AM";
    var formattedHours = hours % 12 === 0 ? 12 : hours % 12;
    var formattedMinutes = minutes < 10 ? "0".concat(minutes) : minutes;
    return "".concat(formattedHours, ":").concat(formattedMinutes, " ").concat(period);
};
exports.convertTime = convertTime;
